import { Location, CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BusinessProvider } from 'src/app/guard/business-details-guard.ts.service';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { CUSTOMER_MENU_ITEMS, CustomerService } from '../customer-service.service';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';





@Component({
  selector: 'app-customer-search',
  standalone: true,
  imports: [CommonModule, FormsModule,
MatMenuModule, NgSelectModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss'],
  host: { 'class': 'customer-search-menu-host' }

})
export class CustomerSearchComponent implements OnInit  {
  businessData: any= null;
  role: any
  @Input() placeholder: string;
  MemberShipType = localStorage.getItem('MemberShipType');
  constructor(
    private API: ApiService,
    public customerService: CustomerService,
    private location: Location,
    private excelService: ExcelService,
    private router: Router,
    private businessProvider: BusinessProvider,
  ) {

    // when user refresh this will trigger
    const data = this.location.path().split("?")[0];
    if (data) {
      this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
      this.updateMenuHeader(this.selectedItem);
    }

    this.router.events.subscribe(res => {
      if (res instanceof NavigationStart) {
        const data = res.url.split("?")[0];
        if (data) {
          this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
          this.updateMenuHeader(this.selectedItem);
          this.filterContext = this.updateFilterScreen();
        }
      }

    });

    const business = this.businessProvider.getBusiness();
    if(business){
      this.businessData = business;
      this.role = business.role;
      console.log("Custoemr search data is here " ,business);
    }

    this.USERID = localStorage.getItem('userId');
  }

  // onMenuOpened() {
  //   document.body.style.overflow = 'hidden';
  // }

  // onMenuClosed() {
  //   document.body.style.overflow = '';
  // }

  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @HostListener('window:scroll', [])
  scrollHandler() {
    for(let index = 0; index < this.trigger.toArray().length; index++) {
      this.trigger.toArray()[index].closeMenu();
    }
  }

  filterContext: any = [];
  USERID: string;
  selectedItem: CUSTOMER_MENU_ITEMS = "plan";
  searchText: string = '';
  onSearch() {
    this.customerService.emitSearch({
      value: this.searchText.trim(),
      key: this.selectedItem
    });

  }


  async ngOnInit(): Promise<void> {
    this.customerService.resetFilterPayload( );
    if (this.selectedItem === 'contacts') {
      await this.loadmembernetworks();
    }
    if (this.selectedItem === 'businessContacts') {
      await this.loadb2bnetworks();
    }
    this.filterContext = this.updateFilterScreen();
  }
  allNetworks: any[] = [];

  loadmembernetworks(): Promise<void> {
    return new Promise((resolve, reject) => {
      const data: any = {
        "businessId": this.businessData.id,
        "limit": 50,
      };
      this.getnetworklist(data).subscribe(res => {
        const networks = res.data.businessNetworkList;
        if (networks && networks.length > 0) {
          const newNetworks = networks.map(network => ({
            value: network.businessNetworkId,
            label: network.businessNetworkName,
          }));
          this.allNetworks = [...this.allNetworks, ...newNetworks];
        }
        resolve();
      }, error => {
        reject(error);
      });
    });
  }

  loadb2bnetworks(): Promise<void> {
    return new Promise((resolve, reject) => {
      const data: any = {
        "businessId": this.businessData.id,
        "limit": 50,
      };

      this.getbusinessnetworklist(data).subscribe(res => {
        const networks = res.data.b2bNetworks;

        if (networks && networks.length > 0) {
          const newNetworks = networks.map(network => ({
            value: network.b2bNetworkId,
            label: network.b2bNetworkName,
          }));

          this.allNetworks = [...this.allNetworks, ...newNetworks];
          resolve();
        } else {
          resolve();
        }
      }, error => reject(error));
    });
  }


  getMultiple(d) {
    return d.label === 'Network Name' ? true : false;
  }

  // Filter helper methods for checkbox-based filtering
  isFilterSelected(payload: string, value: string): boolean {
    const filterValue = this.filterData[payload];
    if (Array.isArray(filterValue)) {
      return filterValue.includes(value);
    }
    return filterValue === value;
  }

  toggleFilter(payload: string, value: string, event: Event, isMultiple: boolean): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isMultiple) {
      // Multi-select: manage as array
      if (!this.filterData[payload]) {
        this.filterData[payload] = [];
      }
      if (isChecked) {
        if (!this.filterData[payload].includes(value)) {
          this.filterData[payload] = [...this.filterData[payload], value];
        }
      } else {
        this.filterData[payload] = this.filterData[payload].filter(v => v !== value);
        if (this.filterData[payload].length === 0) {
          delete this.filterData[payload];
        }
      }
    } else {
      // Single-select: only one value at a time
      if (isChecked) {
        this.filterData[payload] = value;
      } else {
        delete this.filterData[payload];
      }
    }
  }

  hasActiveFilters(): boolean {
    return Object.keys(this.filterData).some(key => {
      const val = this.filterData[key];
      return val !== undefined && val !== null && (Array.isArray(val) ? val.length > 0 : true);
    });
  }

  getActiveFilterCount(): number {
    let count = 0;
    Object.keys(this.filterData).forEach(key => {
      const val = this.filterData[key];
      if (val !== undefined && val !== null) {
        if (Array.isArray(val)) {
          count += val.length;
        } else {
          count += 1;
        }
      }
    });
    return count;
  }

  clearAllFilters(): void {
    this.filterData = {};
    this.filtersCount;
    this.searchText="";
    this.customerService.emitFilter({
      value: this.filterData,
      key: this.selectedItem
    });
  }

  activeScreen: string = "";
  updateMenuHeader(data: string) {
    if (data === "plan" || data === 'billing' || data === 'analytics') {
      this.activeScreen = "TOPUP";
    } else if (data === 'user') {
      this.activeScreen = "USER";
    } else if (data === 'businessNetworks') {
      this.activeScreen = "B2BNETWORKS";
    } else if (data === 'businessContacts') {
      this.activeScreen = "B2BCONTACTS";
    } else if (data === 'contacts') {
      this.activeScreen = "CONTACT";
    } else if (data === 'network') {
      this.activeScreen = "NETWORK";
    } else if (data === 'workSpace') {
      this.activeScreen = "WORKSPACE"
    } else {
      this.activeScreen = "SLOT"
    }
  }
  filterData: any = {};

  get filtersCount(): number {
    return Object.keys(this.filterData).length;
  }

  tooltipModify(val: any, object: any) {
    if (val === undefined || val === null) {
      return '';
    }
    const data = object.options.find(option => option.value === val);
    return data ? data.label : '';
  }


  saveFilter() {
    this.filtersCount;
    this.searchText="";
    this.customerService.emitFilter({
      value: this.filterData,
      key: this.selectedItem
    });
  }


  onDropdownChange(payload: string): void {

    const currentSelection = this.filterData[payload];

    console.log('Current Selection:', currentSelection);
        if (!currentSelection || currentSelection.length === 0) {
            this.saveFilter();
        }
}


  payload = {
    businessId: null,
    email: null,
    limit: 0,
    page: 0,
    statusList: [],
    type: null,
    userId: null,
    searchContent:null,
    groupType:null

  }
  resetPayload() {
    this.payload = {
      businessId: null,
      email: null,
      limit: 0,
      page: 0,
      statusList: [],
      type: null,
      userId: null,
      searchContent:null,
      groupType:null
    };
  }
  downloadExcel() {
    this.resetPayload();
    let filterPayload  = this.customerService.getFilterPayload();
    if (!filterPayload) {
      filterPayload = {};
    }
    this.payload = {
      ...this.payload,
      ...filterPayload,
      limit: this.excelService.getTotalCount(),
      searchContent: this.searchText
    };
    if (this.role === 'SUPERADMIN' && ['Starter','Growth','ScaleX'].includes(this.MemberShipType)) {
      this.payload.businessId = this.businessData.id;
      this.payload.email = (this.selectedItem === 'user')
        ? this.businessData.businessEmail
        : null;
    } else {
      if (this.selectedItem != "network" && this.selectedItem != "businessNetworks") {
        this.payload.userId = localStorage.getItem('userId');
      }
    }
    const statusMapping: { [key: string]: string[] } = {
      user: ["ACTIVE", "INACTIVE", "BLOCKED", "INITIATED"],
      interaction: ["ACTIVE", "INACTIVE", "BLOCKED"],
      jobs: ["ACTIVE", "INACTIVE", "BLOCKED"],
      workSpace: ["ACTIVE", "INACTIVE", "BLOCKED"]
    };
    this.payload.statusList = filterPayload?.statusList?filterPayload?.statusList:statusMapping[this.selectedItem] ;
    this.payload.type = filterPayload?.type?filterPayload?.type:this.getPayloadType(this.selectedItem);

    if (['user', 'jobs', 'interaction'].includes(this.selectedItem)) {
      let header: string;
      this.payload.page = 0;
      this.payload.groupType="LISTING"
      header = this.selectedItem === 'user' ? "Users" :
        this.selectedItem === 'jobs' ? "Job/Candidate Slots" :
          "Interaction Credits";
      if (this.role === 'SUPERADMIN' && ['Starter','Growth','ScaleX'].includes(this.MemberShipType)) {
        this.fetchData(this.getCustomerUsersList(), 'customerUserAllocationList', header);
      } else {
        this.payload.businessId = this.businessData.id;
        this.fetchData(this.getindividualuserlist(), 'userWithBenefit', header);
      }
    } else if (this.selectedItem === 'workSpace') {
      if (this.role == "SUPERADMIN") {
        this.payload.page = 1;
        this.payload.groupType="LISTING"
        this.fetchData(this.getworkspacelist(), 'teams', 'Workspaces');
      } else {
        this.payload.page = 0;
        this.fetchData(this.getemployeeworkspacelist(), 'teams', 'Workspaces');
      }
    } else if (this.selectedItem === 'network') {
      this.payload.page = 1;
      this.payload.businessId = this.businessData.id;
      this.fetchData(this.getnetworklist(), 'businessNetworkList', 'Member Networks');
    } else if (this.selectedItem === 'contacts') {
      this.payload.page = 0;
      this.payload.businessId = this.businessData.id;
      this.payload.type = "LISTING";
      this.fetchData(this.getconatctlist(), 'businessContactList', 'Members');
    } else if (this.selectedItem === 'businessNetworks') {
      this.payload.page = 1;
      this.payload.businessId = this.businessData.id;
      this.fetchData(this.getbusinessnetworklist(), 'b2bNetworks', 'Business Networks');
    } else if (this.selectedItem === 'businessContacts') {
      this.payload.businessId = this.businessData.id;
      this.payload.page = 1;
      this.fetchData(this.getbusinesscontactlist(), 'b2bContacts', 'Business');
    }
  }
  fetchData(apiCall: Observable<any>, dataKey: string, excelheader: string) {
    apiCall.subscribe(res => {
      if (res.code === GigsumoConstants.SUCESSCODE) {
        const headers = this.getHeaders();
        let arr: any[] = [];
        if (res.data && Array.isArray(res.data[dataKey])) {
          arr = res.data[dataKey];
        } else if (res.data && res.data[dataKey]) {
          arr = [res.data[dataKey]];
        }
        if (arr.length > 0) {
          // Excel plan access status changed to Given/Not Given
          const statusMap: any = {
            ACTIVE: 'Given',
            INACTIVE: 'Not Given'
          };
          
          arr.forEach((item: any) => {
            if (statusMap[item.planAccessStatus]) {
              item.planAccessStatus = statusMap[item.planAccessStatus];
            }
          });
          
        this.excelService.downloadExcel(arr, headers, excelheader);
        }
      }
    });
  }


  getCustomerUsersList(): Observable<any> {
    return this.API.create('subscription/findEmployeeBenefitsAllocation', this.payload);
  }

  getworkspacelist(): Observable<any> {
    return this.API.create('teams/findTeamsOfBusiness', this.payload);
  }


  getnetworklist(data?: any): Observable<any> {
    return this.API.create('business/getBusinessUsersNetworkList', data?data:this.payload);
  }

  getconatctlist(): Observable<any> {
    return this.API.create('business/findUserContactsOfBusiness', this.payload);
  }
  getbusinessnetworklist(data?:any): Observable<any> {
    return this.API.create('business/findB2BNetworks', data?data:this.payload);
  }
  getbusinesscontactlist(): Observable<any> {
    return this.API.create('business/findB2BContactsList', this.payload);
  }
  getindividualuserlist(): Observable<any> {
    return this.API.create('subscription/findUserWithBenefitAllocation', this.payload);
  }
  getemployeeworkspacelist(): Observable<any> {
    return this.API.create('teams/findUserOwnedTeams', this.payload);
  }


  getPayloadType(selectedItem: string): string {
    switch (selectedItem) {
      case 'interaction':
        return "ACTIVE_INTERACTIONS";
      case 'jobs':
        return "JOB_CANDIDATE_POSTINGS";
      case 'workSpace':
        return "TEAM_WORKSPACES";
    }
  }
  getHeaders() {

    switch (this.selectedItem) {
      case "user":
        return [
          { header: "Gigsumo ID", key: "GigsumoNo" },
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "username" },
          { header: "Role", key: "userTyperole" },
          { header: "Start Date", key: "createdOn" },
          { header: "Last Active", key: "lastLoggedIn" },
          { header: "Plan Access", key: "planAccessStatus" },
          { header: "Status", key: "userStatus" },
        ];
        break;
      case "interaction":
        return [
          { header: "Gigsumo ID", key: "GigsumoNo" },
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "username" },
          { header: "Role", key: "userTyperole" },
          { header: "Allocated", key: "actual" },
          { header: "Available", key: "available" },
          { header: "Start Date", key: "createdOn" },
          { header: "Last Active", key: "lastLoggedIn" },
          { header: "Plan Access", key: "planAccessStatus" },
          { header: "Status", key: "userStatus" },
        ];
      case "jobs":
        return [
          { header: "Gigsumo ID", key: "GigsumoNo" },
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "username" },
          { header: "Role", key: "userTyperole" },
          { header: "Slots Allowed", key: "actual" },
          { header: "Slots Used", key: "utilized" },
          { header: "Posting Allowed", key: "JOBS_CANDIDATE_ACTIVE_CREATIONS.actual" },
          { header: "Posting Used", key: "JOBS_CANDIDATE_ACTIVE_CREATIONS.utilized" },
          { header: "Featured Allowed", key: "JOBS_CANDIDATE_SPOTLIGHTS.actual" },
          { header: "Featured Used", key: "JOBS_CANDIDATE_SPOTLIGHTS.utilized" },
          { header: "Start Date", key: "createdOn" },
          { header: "Last Active", key: "lastLoggedIn" },
          { header: "Plan Access", key: "planAccessStatus" },
          { header: "Status", key: "userStatus" },
        ];  
      case "workSpace":
        return [
          { header: "Workspace Name", key: "teamName" },
          { header: "User", key: "owner" },
          { header: "Email ID", key: "email" },
          { header: "Role", key: "userTyperole" },
          { header: "Members", key: "memberCnt" },
          { header: "Start Date", key: "createdOn" },
          { header: "Last Active", key: "modifiedOn" },
          { header: "Status", key: "status" },
        ];
      case "network":
        return [
          { header: "Networks", key: "businessNetworkName" },
          { header: "Owner", key: "owner" },
          { header: "Email", key: "email" },
          { header: "Role", key: "Super Admin" },
          { header: "Members", key: "membersCount" },
          { header: "Created Date", key: "createdOn" },
          { header: "Last Active", key: "modifiedOn" },
          { header: "Status", key: "status" },
        ];
      case "contacts":
        return [
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "email" },
          { header: "Role", key: "userTyperole" },
          { header: "Company", key: "company" },
          { header: "Company Type", key: "client" },
          { header: "Contact Type", key: "contactType" },
          { header: "Network", key: "networkName" },
          { header: "Partner since", key: "startDate" },
          { header: "Last Active", key: "lastLoggedOn" },
          { header: "Status", key: "connectionStatus" },
        ];
      case "businessNetworks":
        return [
          { header: "Network Name", key: "b2bNetworkName" },
          { header: "Network Type", key: "Ctype" },
          { header: "Owner", key: "owner" },
          { header: "Email", key: "email" },
          { header: "Role", key: "Super Admin" },
          { header: "Members", key: "membersCount" },
          { header: "Created Date", key: "createdOn" },
          { header: "Last Active", key: "modifiedOn" },
          { header: "Status", key: "status" },
        ];
      case "businessContacts":
        return [
          { header: "Business Name", key: "businessName" },
          { header: "Owner", key: "businessOwner" },
          { header: "Email", key: "businessEmail" },
          { header: "Role", key: "Super Admin" },
          { header: "Business Type", key: "Ctype" },
          { header: "Network Name", key: "BusinessNetworks" },
          { header: "Partner Since", key: "startDate" },
          { header: "Last Active", key: "lastLoggedIn" },
          { header: "Status", key: "connectionStatus" },
        ];
      default:
        break;
    }

  }


 
  checksuperadmin() {
    return this.businessData != null &&
      ( this.businessData.role == "EMPLOYEE" && (this.selectedItem == 'businessNetworks' || this.selectedItem == 'network') ||
      this.businessData.role == "SUPERADMIN" && (this.MemberShipType == "Growth" || this.MemberShipType == "Starter"|| this.MemberShipType == "ScaleX") )

  }
  showSearchBar(): boolean {
    let termsArray = ["plan", "user", "interaction", "jobs", "workSpace", "businessNetworks", "businessContacts", "network", "contacts", "analytics", "billing"];
    return termsArray.includes(this.selectedItem);
  }

  customersStopScroll: boolean = false;
  params: any = {
    limit: 10,
    page: 0,
    total: 0
  };
  selectedUserList: string | null = null;
  Lowercase:"";
  updateFilterScreen() {
    switch (this.selectedItem) {
      case 'user':
      case 'interaction':
      case 'jobs': {
        const statusOptions = [
          { value: 'ACTIVE', label: 'Active' },
          { value: 'INACTIVE', label: 'Inactive' }, 
          { value: 'BLOCKED', label: 'Blocked' },
        ];

        if (this.selectedItem === 'user') {
          statusOptions.push({ value: 'INITIATED', label: 'Initiated' });
        }

        const fields = [
          {
            label: 'Role',
            payload: 'role',
            options: [
              { value: 'FREELANCE_RECRUITER', label: 'Freelance Recruiter' },
              { value: 'MANAGEMENT_TALENT_ACQUISITION', label: 'Manager' },
              { value: 'BENCH_RECRUITER', label: 'Bench Sales Recruiter' },
              { value: 'RECRUITER', label: 'Recruiter' },
            ],
          },
          {
            label: 'Status',
            payload: 'status',
            options: statusOptions,
          } 
        ];

        //  Added the Plan Access  for user & interaction 

        fields.push({
            label: 'Plan Access',
            payload: 'planAccessStatus',
            options: [
              { value: 'ACTIVE', label: 'Given' },
              { value: 'INACTIVE', label: 'Not Given' },
              ...(this.selectedItem === 'user' ? [{ value: 'N/A', label: 'N/A' }] : []),
            ],
          });

 

        return fields;
      }

      case 'workSpace':
        return [
          {
            label: 'Status',
            payload: 'status',
            options: [
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
              { value: 'DEACTIVATED', label: 'Deactivated' },
            ],
          }
        ];
      case 'businessNetworks':
        return [
          {
            label: 'Status',
            payload: 'status',
            options: [
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
            ],
          }, {
            label: 'Network Type',
            payload: 'type',
            options: [
              { value: 'Supplier', label: 'Supplier' },
              { value: 'Client', label: 'Client' },
              // Mutual type. The value sent is the canonical "Client_Supplier";
              // B2BNetworkDao.expandNetworkTypes widens it to every spelling
              // actually stored in the type field ("Client/Supplier" from the
              // Add-Network form, legacy "Customer/Supplier"), so the bucket
              // isn't split by how the row happened to be written.
              { value: 'Client_Supplier', label: 'Client/Supplier' },
            ],
          }
        ];
      case 'businessContacts':
        return [
          {
            label: 'Status',
            payload: 'status',
            options: [
              { value: 'CONNECTED', label: 'Connected' },
              { value: 'INACTIVE', label: 'Inactive' },
              { value: 'REQUEST_SENT', label: 'Requested' },
              { value: 'REQUEST_RECEIVED', label: 'Request Received' },
            ],
          },
          {
            label: 'Business Type',
            payload: 'type',
            options: [
              { value: 'Supplier', label: 'Supplier' },
              { value: 'Client', label: 'Client' },
              // Mutual type. The value sent is the canonical "Client_Supplier";
              // B2BContactDao.expandContactTypes widens it to every spelling
              // actually stored in contactType / peerContactType
              // ("Client/Supplier" from the Add-Business form, legacy
              // "Customer/Supplier"), so the bucket isn't split by how the row
              // happened to be written. Without this option the mutual rows are
              // shown in the Business Type column but unreachable by filter,
              // because plain Client / Supplier deliberately exclude them.
              { value: 'Client_Supplier', label: 'Client/Supplier' },
            ],
          },
          {
            label: 'Network Name',
            payload: 'businessNetworkId',
            options: this.allNetworks,
          },
        ];
      case 'contacts':
        return [
          {
            label: 'Role',
            payload: 'userType',
            options: [
              { value: 'RECRUITER', label: 'Recruiter' },
              { value: 'BENCH_RECRUITER', label: 'Bench Recruiter' },
              { value: 'FREELANCE_RECRUITER', label: 'Freelancer Recruiter' },
              { value: 'MANAGEMENT_TALENT_ACQUISITION', label: 'Manager' },
              { value: 'JOB_SEEKER', label: 'Job Seeker' },
            ],
          },
          {
            label: 'Contact Type',
            payload: 'organisationType',
            options: [
              { value: 'Supplier', label: 'Supplier' },
              { value: 'Client', label: 'Client' },
            ],
          },
          {
            label: 'Network Name',
            payload: 'businessNetworks',
            options: this.allNetworks,
          },
        ];
      // NOTE: a second 'businessNetworks' case used to sit here. It was
      // unreachable — the switch already matches the case above — and it still
      // carried the old two-option Network Type list, so it read like the live
      // definition while changing nothing. Removed with the Client/Supplier
      // option (2026-09-22); edit the 'businessNetworks' case above instead.
      default:
        return [
          {
            label: 'Status',
            payload: 'status',
            options: [
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
            ],
          },
        ];
    }
  }



  onCustomerSearch(e) {
    this.customerPayload.searchContent = e;
    this.companyName().subscribe(response => {
      const customerList = response.data.b2bContacts.map((response: any) => ({
        value: response.data.organisationId
      }))
      this.customersList.next(customerList);
    })
  }


  customerPayload = {
    businessId: null,
    // businessNetworks: [],
    businessCustomers: [],
    searchContent: null,
    searchAfterKey: null,
    limit: 10
  };

  onSelectChange(event) {
    if (event) {
      this.customerPayload.businessCustomers = event.target.value
    }
  }
  companyName(): Observable<any> {
    return this.API.create('business/findBusinessCustomers', this.customerPayload);
  }

  onCustomerScroll(e) {
    this.customerPayload = {
      ...this.customerPayload,
      searchAfterKey: this.customersPrevSearchAfterKey
    }
    this.companyName();
  }

  customersPrevSearchAfterKey: any;
  customersList = new BehaviorSubject<any[]>([]);
  isLoading: boolean = false;
  // getBusinessCustomers() {
  //   this.isLoading = true;
  //   this.customerPayload.businessId = localStorage.getItem('businessId');
  //   this.API.create("business/findBusinessCustomers", this.customerPayload).subscribe(response=>{
  //     if(response.code === GigsumoConstants.SUCESSCODE){

  //       const users = response.data.b2bContacts;
  //       const searchKey = response.data.searchAfterKey;

  //       if (users) {
  //         const current = users;
  //         const exist = this.customersList.getValue();
  //         let data = (this.customerPrevSelectedValue  &&
  //         this.customerPrevSelectedValue.length > 0) ? exist.concat(this.customerPrevSelectedValue)
  //         : exist;

  //         let finalData = this.gigsumoService.removeDuplicatesKey([...data, ...current] , 'businessId');
  //         this.customersList.next(finalData);
  //       }

  //       if (
  //         users != null && (users.length === 0 || JSON.stringify(this.customersPrevSearchAfterKey) ===  JSON.stringify(searchKey))
  //       ) {
  //         this.customersStopScroll = true;
  //       }

  //       this.customersPrevSearchAfterKey = searchKey;

  //       this.isLoading = false;
  //     }
  //   });
  // }
}
